module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showboo),
      expression: "showboo"
    }],
    ref: "returnbutton",
    staticClass: "returnbutton"
  }, [_c('div', {
    staticClass: "returnbutton-buttoin",
    on: {
      "click": function($event) {
        _vm.buttoinclick()
      }
    }
  }, [_vm._v("\n               " + _vm._s(_vm.$t('back')) + "\n            ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4111b60","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mymessage/returnbutton.vue
// module id = 484
// module chunks = 1